// Room tablet "Call for help" (api v2-room-r2, 10-23): a NON-emergency flag the patient raises from the
// room tablet, stored as appointment_master.signintime.help_request = {status, id, room, requestedAt}.
// Shown here as an amber "Help requested · Room X" badge with "Done"; the red URGENT banner stays
// driven by signintime.emergency_alert (real emergencies only).
import careiqapi from "../api/careiqapi";

// [{appointmentid, patientid, roomName, requestedAt}] of the rooms with an open help request.
export function openHelpRequests(rooms) {
  const out = [];
  (rooms || []).forEach((room) => {
    (room.patients || []).forEach((p) => {
      const hr = p.helprequest;
      if (hr && typeof hr === "object" && hr.status === "open") {
        out.push({ appointmentid: p.appointmentid, patientid: p.patientid, roomName: room.name,
                   requestedAt: hr.requestedAt || null });
      }
    });
  });
  return out;
}

// Closes the request (v2 only route: care login, practice claim enforced).
export async function closeRoomHelp(practiceid, appointmentid) {
  const r = await careiqapi.post(`/v1/${practiceid}/room-dashboard/help-requests/close`,
                                 { appointmentid: Number(appointmentid) });
  return r && r.data;
}
